const LARGE_ZOOM_MAP = {
  tt: 3.42,
  mh: 5.28,
  ka: 5.77,
  tn: 6.13,
  ap: 5.3,
  dl: 9.24,
  up: 5.34,
  wb: 5.97,
  br: 5.96,
  tg: 6.28,
  gj: 5.56,
  as: 5.58,
  rj: 5.14,
  or: 5.69,
  hr: 6.62,
  mp: 5.16,
  kl: 6.4,
  pb: 6.63,
  jk: 6.53,
  jh: 6.08,
  ct: 5.87,
  ut: 6.56,
  ga: 8.67,
  tr: 7.85,
  py: 8.29,
  mn: 7.49,
  hp: 6.51,
  nl: 7.25,
  ar: 5.69,
  an: 5.82,
  la: 5.28,
  ch: 10.93,
  dn: 9.58,
  ml: 6.69,
  sk: 8.42,
  mz: 7.1,
  ld: 7.68,
}

export default LARGE_ZOOM_MAP
